import {
  FaAddressCard,
  FaFolderOpen,
  FaSitemap,
  FaUsers,
} from "react-icons/fa";
import { MdDashboard, MdEvent, MdNewspaper, MdSettings } from "react-icons/md";
import { HiOutlineBuildingOffice2 } from "react-icons/hi2";
import { TbBooks, TbFolderHeart } from "react-icons/tb";
import { RiGalleryFill } from "react-icons/ri";
import { GiLargePaintBrush } from "react-icons/gi";
import { SlEarphonesAlt } from "react-icons/sl";

export const ADMIN_NAVBAR_OFFSET = "88px";

export const ADMIN_SIDEBAR_WIDTHS = {
  expanded: "w-80",
  collapsed: "w-[96px]",
};

export const ADMIN_SIDEBAR_MARGINS = {
  expanded: "lg:ml-80",
  collapsed: "lg:ml-[96px]",
};

export const DEFAULT_MODULE_META = {
  icon: MdDashboard,
  gradient: "from-sky-600 via-cyan-500 to-blue-500",
  softBg: "bg-sky-50 dark:bg-sky-500/10",
  softText: "text-sky-700 dark:text-sky-300",
  description: "Accéder à cette rubrique.",
};

export const MODULE_META = {
  dashboard: {
    icon: MdDashboard,
    gradient: "from-sky-600 via-cyan-500 to-blue-500",
    softBg: "bg-sky-50 dark:bg-sky-500/10",
    softText: "text-sky-700 dark:text-sky-300",
    description: "Vue globale du site et des actions importantes.",
  },
  news: {
    icon: MdNewspaper,
    gradient: "from-orange-500 via-amber-500 to-yellow-400",
    softBg: "bg-orange-50 dark:bg-orange-500/10",
    softText: "text-orange-700 dark:text-orange-300",
    description: "Publier les actualités de la commune.",
  },
  events: {
    icon: MdEvent,
    gradient: "from-violet-600 via-fuchsia-500 to-pink-500",
    softBg: "bg-violet-50 dark:bg-violet-500/10",
    softText: "text-violet-700 dark:text-violet-300",
    description: "Gérer l’agenda et les événements.",
  },
  publications: {
    icon: TbBooks,
    gradient: "from-emerald-600 via-teal-500 to-cyan-500",
    softBg: "bg-emerald-50 dark:bg-emerald-500/10",
    softText: "text-emerald-700 dark:text-emerald-300",
    description: "Ajouter les documents publics.",
  },
  projets: {
    icon: GiLargePaintBrush,
    gradient: "from-indigo-600 via-blue-500 to-sky-400",
    softBg: "bg-indigo-50 dark:bg-indigo-500/10",
    softText: "text-indigo-700 dark:text-indigo-300",
    description: "Présenter les grands projets municipaux.",
  },
  associations: {
    icon: HiOutlineBuildingOffice2,
    gradient: "from-rose-600 via-pink-500 to-fuchsia-500",
    softBg: "bg-rose-50 dark:bg-rose-500/10",
    softText: "text-rose-700 dark:text-rose-300",
    description: "Référencer les associations locales.",
  },
  commerces: {
    icon: HiOutlineBuildingOffice2,
    gradient: "from-lime-600 via-green-500 to-emerald-500",
    softBg: "bg-lime-50 dark:bg-lime-500/10",
    softText: "text-lime-700 dark:text-lime-300",
    description: "Mettre en avant les commerces.",
  },
  "services-municipaux": {
    icon: SlEarphonesAlt,
    gradient: "from-cyan-600 via-sky-500 to-blue-500",
    softBg: "bg-cyan-50 dark:bg-cyan-500/10",
    softText: "text-cyan-700 dark:text-cyan-300",
    description: "Organiser les services de la mairie.",
  },
  trombinos: {
    icon: FaAddressCard,
    gradient: "from-blue-700 via-indigo-600 to-violet-500",
    softBg: "bg-blue-50 dark:bg-blue-500/10",
    softText: "text-blue-700 dark:text-blue-300",
    description: "Gérer les élus et membres municipaux.",
  },
  menus: {
    icon: FaSitemap,
    gradient: "from-slate-700 via-slate-600 to-slate-500",
    softBg: "bg-slate-100 dark:bg-slate-800",
    softText: "text-slate-700 dark:text-slate-200",
    description: "Structurer la navigation du site.",
  },
  pages: {
    icon: FaFolderOpen,
    gradient: "from-purple-600 via-violet-500 to-indigo-500",
    softBg: "bg-purple-50 dark:bg-purple-500/10",
    softText: "text-purple-700 dark:text-purple-300",
    description: "Créer et modifier les pages personnalisées.",
  },
  photos: {
    icon: RiGalleryFill,
    gradient: "from-pink-600 via-rose-500 to-red-500",
    softBg: "bg-pink-50 dark:bg-pink-500/10",
    softText: "text-pink-700 dark:text-pink-300",
    description: "Gérer les images et la médiathèque.",
  },
  "albums-photos": {
    icon: RiGalleryFill,
    gradient: "from-pink-600 via-rose-500 to-red-500",
    softBg: "bg-pink-50 dark:bg-pink-500/10",
    softText: "text-pink-700 dark:text-pink-300",
    description: "Gérer les albums photo de la commune.",
  },
  utilisateurs: {
    icon: FaUsers,
    gradient: "from-red-600 via-orange-500 to-amber-400",
    softBg: "bg-red-50 dark:bg-red-500/10",
    softText: "text-red-700 dark:text-red-300",
    description: "Gérer les comptes et les accès.",
  },
  parametres: {
    icon: MdSettings,
    gradient: "from-slate-800 via-slate-700 to-slate-600",
    softBg: "bg-slate-100 dark:bg-slate-800",
    softText: "text-slate-700 dark:text-slate-200",
    description: "Configurer l’identité du site.",
  },
  abonnement: {
    icon: TbFolderHeart,
    gradient: "from-teal-600 via-emerald-500 to-lime-400",
    softBg: "bg-teal-50 dark:bg-teal-500/10",
    softText: "text-teal-700 dark:text-teal-300",
    description: "Suivre l’offre MonAppliMairie.",
  },
};

export const PAGE_TITLES = [
  {
    match: "/appli/dashboard",
    label: "Tableau de bord",
    helper: "Vue d’ensemble de votre site municipal.",
  },
  {
    match: "/appli/news",
    label: "Actualités",
    helper: "Publiez rapidement les informations importantes.",
  },
  {
    match: "/appli/events",
    label: "Agenda / Événements",
    helper: "Ajoutez les rendez-vous de la commune.",
  },
  {
    match: "/appli/publications",
    label: "Publications",
    helper: "Documents, comptes rendus, arrêtés et fichiers publics.",
  },
  {
    match: "/appli/projets",
    label: "Grands projets",
    helper: "Présentez les projets municipaux aux habitants.",
  },
  {
    match: "/appli/associations",
    label: "Associations",
    helper: "Annuaire des associations locales.",
  },
  {
    match: "/appli/commerces",
    label: "Commerces",
    helper: "Annuaire économique de la commune.",
  },
  {
    match: "/appli/services-municipaux",
    label: "Services municipaux",
    helper: "Coordonnées et informations pratiques.",
  },
  {
    match: "/appli/trombinos",
    label: "Trombinoscope",
    helper: "Élus, équipe municipale et commissions.",
  },
  {
    match: "/appli/menus",
    label: "Menus",
    helper: "Organisez les liens du site public.",
  },
  {
    match: "/appli/pages",
    label: "Pages personnalisées",
    helper: "Créez des contenus sur mesure pour la commune.",
  },
  {
    match: "/appli/photos",
    label: "Médiathèque",
    helper: "Centralisez les images du site.",
  },
  {
    match: "/appli/albums-photos",
    label: "Albums-Photos",
    helper: "Gérez les albums photo de la commune.",
  },
  {
    match: "/appli/utilisateurs",
    label: "Utilisateurs",
    helper: "Gérez les administrateurs et leurs autorisations.",
  },
  {
    match: "/appli/parametres",
    label: "Paramètres du site",
    helper: "Logo, couleurs, coordonnées et configuration.",
  },
  {
    match: "/appli/abonnement",
    label: "Abonnement",
    helper: "Suivi de l’offre et des informations client.",
  },
];

export function getModuleMeta(moduleKey) {
  return MODULE_META[moduleKey] || DEFAULT_MODULE_META;
}

export function getPageMeta(pathname = "") {
  return (
    PAGE_TITLES.find((item) => pathname.startsWith(item.match)) || {
      label: "Administration",
      helper: "Pilotez simplement les contenus du site.",
    }
  );
}
